import type { ChangeEventHandler, FC, FocusEventHandler } from 'react';
import { forwardRef } from 'react';

type Props = {
  label: string;
  errorMessage?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  id?: string;
  'data-testid'?: string;
};

const FormCheckbox: FC<Props> = forwardRef<HTMLInputElement, Props>(
  ({ label, errorMessage, ...props }, ref) => (
    <div className="text-left text-lg font-bold leading-9 tracking-tight text-gray-900">
      <label className="block text-base leading-6 text-gray-600">
        <input
          className="size-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500"
          type="checkbox"
          {...props}
          ref={ref}
        />
        <span className="pl-2">{label}</span>
      </label>

      {errorMessage && (
        <p className="mt-2 text-sm font-light text-red-600">{errorMessage}</p>
      )}
    </div>
  ),
);

FormCheckbox.displayName = 'FormCheckbox';

export { FormCheckbox };
